import { useTranslation } from 'react-i18next'
import { CloudOff } from 'lucide-react'
import { Button } from './Button'

interface Props {
  title?: string
  message?: string
  onRetry?: () => void
}

export function ErrorState({ title, message, onRetry }: Props) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
      <CloudOff className="h-10 w-10 text-sage-400" strokeWidth={1.4} aria-hidden />
      <h2 className="font-serif text-xl text-sage-800">{title ?? t('app.error')}</h2>
      {message && <p className="text-sm text-sage-600 max-w-xs">{message}</p>}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>{t('actions.retry')}</Button>
      )}
    </div>
  )
}
